<template>
  <div class="page">
    <div class="pagebanner pagebanner1" :style="{background:'url('+pagebanner+') center 0 no-repeat'}">
      <div class="w1200">
        <h1 class="bounceInUp wow" data-wow-duration="1s" data-wow-delay="0">{{pagetitle}}</h1>
        <span class="bounceInUp wow" data-wow-duration="1s" data-wow-delay="0.2s">{{pagedesc}}</span>
      </div>
    </div>
    <div class="page-main">
      <div class="w1200">
        <div class="newspage">
          <div class="page-main-locationt">
            {{ $t('newslist')}}/{{newsnav}}/<font>{{title}}</font>
          </div>
          <h1>{{title}}</h1>
          <span>{{time}}</span>
          <div class="newspage-content" v-html="content">
          </div>
          <div class="newspage-bottom">
            <div @click="backlist">{{newsnav}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Fetch from '../js/ajax'
export default {
  name: 'Environment',
  metaInfo () {
    return {
      title: this.metatitle,
      meta: [{
        name: 'keywords',
        content: this.keyword
      }]
    }
  },
  data () {
    return {
      pagetitle: '',
      pagedesc: '',
      pagebanner: '',
      title: '',
      newsnav: '',
      time: '',
      content: '',
      newsid: 0,
      keyword: '',
      description: '',
      metatitle: ''
    }
  },
  mounted () {
  },
  methods: {
    backlist () {
      if (this.newsid === 1 || this.newsid === 3) {
        this.$router.push({name: 'newslist'})
      } else {
        this.$router.push({name: 'building'})
      }
    }
  },
  created () {
    const that = this
    Fetch.post('Api/column', {
      id: 6
    }).then((res) => {
      that.pagetitle = res.result.title
      that.pagedesc = res.result.sub_title
      that.pagebanner = res.result.image
    }).catch(err => {
      console.log(err)
    })
    Fetch.post('Api/detailed', {
      id: parseInt(that.$route.params.id)
    }).then((res) => {
      that.metatitle = res.result.title + '浙江金科日化原料有限公司'
      that.keyword = res.result.keyword
      console.log(that.keyword)
      that.title = res.result.title
      that.time = res.result.sub_title
      that.newsid = res.result.classify.id
      that.newsnav = res.result.classify.title
      that.content = res.result.content
    }).catch(err => {
      console.log(err)
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .page-main{
    min-height: 400px;
    padding: 0 40px;
    overflow: hidden;
  }
  .pagebanner{
    height: 600px;
    overflow: hidden;
  }
  .pagebanner6{
    background: url(../assets/pagebanner6.png) center 0 no-repeat;
  }
  .pagebanner h1{
    height: 60px;
    display: block;
    line-height: 60px;
    margin-top: 271px;
    text-align: center;
    font-size: 40px;
    font-weight: bold;
    color: #fff;
  }
  .pagebanner span{
    overflow: hidden;
    height: 41px;
    display: block;
    line-height: 41px;
    text-align: center;
    font-size: 20px;
    color: #fff;
  }
  .content{
    width: 100%;
    height: auto;
    overflow: hidden;
    padding: 0 30px;
  }
  .page-main-locationt{
    width: 100%;
    height: 23px;
    margin-top: 46px;
    color: #999999;
  }
  .newspage{
    width: 100%;
    height: auto;
    overflow: hidden;
    padding-bottom:50px;
  }
  .page-main-locationt font{
    color: #E40A1F;
    font-weight: bold;
  }
  .newspage h1{
    display: block;
    width: 100%;
    height: auto;
    line-height: 40px;
    margin-top: 24px;
    font-size: 30px;
    font-weight: bold;
    color: #333;
  }
  .newspage span{
    display: block;
    width: 100%;
    margin-top: 15px;
    color: #999;
    height: 25px;
  }
  .newspage-content{
    width: 100%;
    height: auto;
    overflow: hidden;
    margin-top: 20px;
  }
  .newspage-bottom{
    width: 100%;
    height: 28px;
    display: flex;
    justify-content: flex-end;
    margin-top: 58px;
  }
  .newspage-bottom div{
    padding-left: 46px;
    width: 108px;
    text-align: center;
    height: 28px;
    background: #e40a1f url(../assets/newspage.jpg) 0 0 no-repeat;
    color: #fff;
    line-height: 28px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/newspage.vue